import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {AngularFireDatabase} from '@angular/fire/database';
import {Error} from "./error";


@Injectable()
export class ErrorService {

  static errorPath = '/error/';

  constructor(private db:AngularFireDatabase) {
  }

  findErrorsForClubId(id: string): Observable<Error[]> {
    // return this.db.list(FieldsService.fieldsPath + id).valueChanges().map(Field.fromJsonArray)
    return this.db.list(ErrorService.errorPath + id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Error.toError({ $key, ...action.payload.val() });
        })
      })
  }

}
